export default "__VITE_ASSET__D4juaamJ__"